import React, { Component } from "react";
import "../css/Option.css";
import { faUserCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Option extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  handleChangeParentState = () => {
    // 부모 컴포넌트로 전달된 콜백 함수 호출
    this.props.updateParentState(true);
  };

  render() {
    const { isHovered } = this.state;

    return (
      <div
        className={`scrolling-dialog ${isHovered ? "hovered" : ""}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleChangeParentState}
      >
        <h3>
          <FontAwesomeIcon icon={faUserCog} /> 옵션
        </h3>
      </div>
    );
  }
}

export default Option;
